import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash';

type ValueType = number;

@Pipe({
  name: 'formatBytes',
  pure: true,
})
export class FormatBytesPipe implements PipeTransform {
  transform(value: ValueType | null | undefined, decimals = 2): string {
    if (isNil(value)) {
      return '';
    }

    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(value) / Math.log(k));

    return `${parseFloat((value / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }
}
